<template>
  <div>
    <h3 class="pt-0 mt-0 pb-0">{{ $t('viewAnalytics.workers.title') }}
      <v-card elevation="0">
        <v-row class="px-3">
          <v-col cols="6" md="3">
            <date-picker
                outlined
                :date-label="$t('viewAnalytics.start_date')"
                :date.sync="dateInterval.start"
                @change="changeInterval"
            />
          </v-col>
          <v-col cols="6" md="3">
            <date-picker
                outlined
                :date-label="$t('viewAnalytics.end_date')"
                :date.sync="dateInterval.end"
                @change="changeInterval"
            />
          </v-col>
        </v-row>
        <v-data-table
            :headers="orderAnalyticsHeader"
            :items="orderAnalyticsData"
            elevation="0"
            hide-default-footer
            class="px-3"
        >
          <template v-slot:item.proportion_of_parts="props">
            {{props.item.proportion_of_parts}}%
          </template>
          <template v-slot:item.average_margin_for_parts="props">
            {{props.item.average_margin_for_parts}}%
          </template>
          <template v-slot:item.total_sum_with_margin="props">
            <span class="text-no-wrap">
              {{ formatCurrency(props.item.total_sum_with_margin) }}
            </span>
          </template>
          <template v-slot:item.part.sum_with_margin="props">
            <span class="text-no-wrap">
              {{ formatCurrency(props.item.part && props.item.part.sum_with_margin || 0) }}
            </span>
          </template>
          <template v-slot:item.repairtime.sum_with_margin="props">
            <span class="text-no-wrap">
              {{formatCurrency(props.item.repairtime && props.item.repairtime.sum_with_margin || 0)}}
            </span>
          </template>
          <template v-slot:item.ARPU="props">
            <span class="text-no-wrap">
              {{formatCurrency(props.item.ARPU)}}
            </span>
          </template>

          <template v-slot:item.gross_profit_per_order="props">
            <span class="text-no-wrap">
              {{formatCurrency(props.item.gross_profit_per_order)}}
            </span>
          </template>
          <template v-slot:item.average_cost_repairtime="props">
            <span class="text-no-wrap">
              {{formatCurrency(props.item.average_cost_repairtime)}}
            </span>
          </template>
          <template v-slot:item.part.sum_without_margin="props">
            <span class="text-no-wrap">
              {{formatCurrency(props.item.part && props.item.part.sum_without_margin || 0)}}
            </span>
          </template>
        </v-data-table>

        <v-row  class="px-3">
          <v-col cols="12">
            <v-progress-circular
                v-if="loadingInProcess.workers_repairtimes"
                size="64"
                indeterminate
                color="primary"
                class="mx-auto d-block"
            ></v-progress-circular>
            <GChart
                v-if="workersRepairtimesData && !loadingInProcess.workers_repairtimes"
                :settings="{ packages: ['corechart'] }"
                :data="workersRepairtimesData"
                :options="workersRepairtimesOptions"
                type="ColumnChart"
                @ready="onChartReady"
            />
            <template v-if="this.workers_repairtimes && this.workers_repairtimes.length===0 && !loadingInProcess.workers_repairtimes">
              <v-alert
                  type="warning"
              >
                {{ $t('viewAnalytics.statuses.workers_repairtimes') }}. {{$t('viewAnalytics.No_data_for_Selected_time_period')}}
              </v-alert>
            </template>
          </v-col>
          <v-col cols="12" md="6">
            <!--выручка по сотрудникам -->
            <GChart
                v-if="revenueByWorkersData && !loadingInProcess.order_analytics"
                :settings="{ packages: ['corechart'] }"
                :data="revenueByWorkersData"
                :options="revenueByWorkersOptions"
                type="ColumnChart"
                @ready="onChartReady"
            /></v-col>
          <v-col cols="12" md="6">
            <!--средний чек по сотрудникам -->
            <GChart
                v-if="ARPUByWorkersData && !loadingInProcess.order_analytics"
                :settings="{ packages: ['corechart'] }"
                :data="ARPUByWorkersData"
                :options="ARPUByWorkersOptions"
                type="ColumnChart"
                @ready="onChartReady"
            /></v-col>
          <v-col cols="12" md="6">
            <!--количество сделок по сотрудникам -->
            <GChart
                v-if="totalNumberOfDealsData && !loadingInProcess.order_analytics"
                :settings="{ packages: ['corechart'] }"
                :data="totalNumberOfDealsData"
                :options="totalNumberOfDealsOptions"
                type="ColumnChart"
                @ready="onChartReady"
            /></v-col>
          <v-col cols="12" md="6">
            <!--продано работ и запчастей по сотрудникам -->
            <GChart
                v-if="partsAndRepairtimeSumData && !loadingInProcess.order_analytics"
                :settings="{ packages: ['corechart'] }"
                :data="partsAndRepairtimeSumData"
                :options="partsAndRepairtimeSumOptions"
                type="ColumnChart"
                @ready="onChartReady"
            /></v-col>
          <v-col cols="12" md="6">
            <!--закрыто часов -->
            <GChart
                v-if="sumRepairtimesData && !loadingInProcess.order_analytics"
                :settings="{ packages: ['corechart'] }"
                :data="sumRepairtimesData"
                :options="sumRepairtimesOptions"
                type="ColumnChart"
                @ready="onChartReady"
            />
          </v-col>
          <v-col cols="12" md="6">
            <!--Доля запчастей -->
            <GChart
                v-if="proportionOfPartsData && !loadingInProcess.order_analytics"
                :settings="{ packages: ['corechart'] }"
                :data="proportionOfPartsData"
                :options="proportionOfPartsOptions"
                type="ColumnChart"
                @ready="onChartReady"
            /></v-col>
        </v-row>


      </v-card>
    </h3>
  </div>
</template>

<script>
import { GChart } from 'vue-google-charts';
import {mapFields} from 'vuex-map-fields';
import DatePicker from "@/components/common/DatePicker";
import CommonMixin from "@/mixins/common";
import { roundToTwo } from "@/fn/math";

export default {
  name: "Workers",
  components: {DatePicker, GChart},
  mixins: [CommonMixin],
  data:() => ({
    dateFormat: "DD.MM.YYYY",
    chartsLib: null,
    statuses:{
      READY: 4, //ID в базе, см StatusSystemOrderRepairtime на бэке
      IN_THE_WORK: 3, //ID в базе, см StatusSystemOrderRepairtime на бэке
    },
    dateInterval:{
      start: null,
      end: null
    },
    selectedStartDate: null,
    commonChartOptions: {
      legend: { position: 'bottom' },
      hAxis: {
        format: 'integer',
      },
      vAxis: {
        minValue:0,
        maxValue:2,
        format: '#'
      },
      height: 400,
      width:"100%",
      chartArea: {
        width: '95%',
        left:100
      },
      pointSize: 10,
      pointsVisible: true,
      curveType: 'function',
    }
  }),
  created() {
    this.$store.dispatch('targets/get');

    let monthBefore = new Date();
    monthBefore.setMonth(monthBefore.getMonth() - 1);

    let dd = String(monthBefore.getDate()).padStart(2, '0');
    let mm = String(monthBefore.getMonth() + 1).padStart(2, '0'); //January is 0!
    let yyyy = monthBefore.getFullYear();
    this.dateInterval.start = yyyy+'-'+mm + '-' + dd;

    let today = new Date();
    dd = String(today.getDate()).padStart(2, '0');
    mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    yyyy = today.getFullYear();
    this.dateInterval.end = yyyy+'-'+mm + '-' + dd;
    this.changeInterval();

  },
  watch: {

  },
  computed: {
    ...mapFields('analytics', [
      'workers_repairtimes',
      'loadingInProcess',
      'order_analytics', //по сотрудникам
    ]),
    ...mapFields('targets', [
      'fetched',
      'types',
      'added'
    ]),
    startDateFormatted() {
      return this.$moment(this.dateInterval.start).format(this.dateFormat)
    },
    endDateFormatted() {
      return this.$moment(this.dateInterval.end).format(this.dateFormat)
    },
    intervalDaysCount(){ //дней между интервалами
      let startDateParts = this.dateInterval.start.split("-");
      let endDateParts = this.dateInterval.end.split("-");
      let start = new Date(startDateParts[0], startDateParts[1] - 1, startDateParts[2].substr(0,2));
      let end = new Date(endDateParts[0], endDateParts[1] - 1, endDateParts[2].substr(0,2));

      return  (end.getTime() - start.getTime()) / (1000 * 60 * 60 * 24);
    },
    orderAnalyticsData(){
      if( ! this.order_analytics.length) return [];
      let ret = [];
      for(let i in this.order_analytics){
        let item = JSON.parse(JSON.stringify(this.order_analytics[i]));
        let tmp = {...(item)};
        //НЧ на 1 МЗД
        tmp.repairtimes_per_deal = (item.repairtime && item.repairtime.sum_repairtimes && item.total_number_of_deals) ? roundToTwo(item.repairtime.sum_repairtimes/item.total_number_of_deals) : 0;
        if(tmp.repairtime){
          tmp.repairtime.sum_repairtimes = tmp.repairtime && tmp.repairtime.sum_repairtimes && roundToTwo(tmp.repairtime.sum_repairtimes) || 0;
        }
        //Средний чек
        tmp.ARPU = (item.total_number_of_deals>0) ? roundToTwo((item.total_sum_with_margin / item.total_number_of_deals)) : 0;
        //Доля запчастей
        tmp.proportion_of_parts = (item.part && item.total_sum_with_margin>0) ? roundToTwo((item.part.sum_with_margin / item.total_sum_with_margin)*100) : 0;
        //Ср. стоим. НЧ
        tmp.average_cost_repairtime = (item.repairtime && item.repairtime.sum_repairtimes>0) ? roundToTwo(item.repairtime.sum_with_margin / item.repairtime.sum_repairtimes) : 0;
        //Наценка на запчасти
        tmp.average_margin_for_parts = (item.part && item.part.sum_with_margin>0) ? roundToTwo(((item.part.sum_with_margin / item.part.sum_without_margin-1)*100)) : 0;
        //Валовая Прибыль на 1 ЗН
        tmp.gross_profit_per_order = (item.part) ? roundToTwo((item.total_sum_with_margin-item.part.sum_without_margin)/item.total_number_of_deals) : 0;
        //Выручка
        tmp.total_sum_with_margin = tmp.total_sum_with_margin > 0 ? roundToTwo(tmp.total_sum_with_margin) : 0;

        if(tmp.part){
          tmp.part.sum_with_margin = roundToTwo(tmp.part.sum_with_margin);
        }
        ret.push(tmp);
      }
      return ret;
    },

    workersRepairtimesOptions () {
      if (!this.chartsLib) return null;

      let count = this.workers_repairtimes.reduce((accumulator, item) => {
        return accumulator + (item.cnt || 0);
      }, 0);
      let cfg = {
        title: `${this.$t('viewAnalytics.statuses.workers_repairtimes')} [${this.$t('viewAnalytics.from')} ${this.startDateFormatted} ${this.$t('viewAnalytics.to')} ${this.endDateFormatted}]`,
        colors: ['#d2dbe2', '#d3a921', '#0055ff'],
      }
      return {...this.commonChartOptions, ...cfg};
    },

    workersRepairtimesData(){
      let res = [];
      if(this.workers_repairtimes.length){
        res.push(
            [this.$t('viewAnalytics.worker'), this.$t('viewAnalytics.statuses.in_the_work'), this.$t('viewAnalytics.statuses.ready'), this.$t('viewAnalytics.finances.planned')]
        );
        let preparedData = [];
        this.workers_repairtimes.forEach((item)=>{
          preparedData[item.name] = {
            name: item.name,
            READY: 0,
            IN_THE_WORK: 0
          }

          this.workers_repairtimes.forEach((one)=>{
            if(one.name === item.name){
              switch(parseInt(one.status_id)){
                case this.statuses.READY:
                    preparedData[item.name].READY = one.repairtimes_cnt;
                  break;
                case this.statuses.IN_THE_WORK:
                  preparedData[item.name].IN_THE_WORK = one.repairtimes_cnt;
                  break;
              }
              preparedData[item.name].user_id = one && one.user_id || null;
            }
          })

        });
        for(let i in preparedData){
          let userTargetDealsPerDay = this.added.find(item =>{
            return (item.parameter === 'repairtimes_per_day' && ( parseInt(item.user_id) === parseInt(preparedData[i].user_id)))
          });
          userTargetDealsPerDay = userTargetDealsPerDay ? parseFloat(userTargetDealsPerDay.value) : 0;

          let name = (!!preparedData[i].name) ? preparedData[i].name :  this.$t('viewAnalytics.not_specified');
          let plan = parseFloat(userTargetDealsPerDay*this.intervalDaysCount);
          res.push([name, parseFloat(preparedData[i].READY), parseFloat(preparedData[i].IN_THE_WORK), plan]);
        }
        return res;
      }
      return null;
    },

    revenueByWorkersData(){
      let res = [];
      if(this.orderAnalyticsData.length){
        res.push(
            [
                this.$t('viewAnalytics.finances.total_sum_with_margin')+'('+this.currencySymbol+')',
                this.$t('viewAnalytics.sum')+'('+this.currencySymbol+')',
                {type: 'string', role: 'tooltip'},
                this.$t('viewAnalytics.finances.planned')+'('+this.currencySymbol+')',
                {type: 'string', role: 'tooltip'},

            ]
        );
        this.orderAnalyticsData.forEach((item)=>{

          let userTargetRevenuePerDay = this.added.find(el =>{
            return (el.parameter === 'revenue_per_day' && ( parseInt(el.user_id) === parseInt(item.user_id)))
          });
          userTargetRevenuePerDay = userTargetRevenuePerDay ? parseFloat(userTargetRevenuePerDay.value) : 0;
          res.push([
              item.name,
              item.total_sum_with_margin,
              item.name+'\n'+this.$t('viewAnalytics.finances.ARPU.title')+': '+this.formatCurrency(item.total_sum_with_margin),
              parseFloat(userTargetRevenuePerDay*this.intervalDaysCount),
              item.name+'\n'+this.$t('viewAnalytics.finances.ARPU.title')+': '+ this.formatCurrency(parseFloat(userTargetRevenuePerDay*this.intervalDaysCount)),
          ]);
        });
        return res;
      }
      return null;
    },
    revenueByWorkersOptions(){
      if (!this.chartsLib) return null;
      let cfg = {
        title: `${this.$t('viewAnalytics.finances.revenue.title')} [${this.$t('viewAnalytics.from')} ${this.startDateFormatted} ${this.$t('viewAnalytics.to')} ${this.endDateFormatted}]`,
        colors: ['#2a59cb'],
        legend: {position: 'none'}
      }
      return {...this.commonChartOptions, ...cfg};
    },

    ARPUByWorkersData(){
      let res = [];
      if(this.orderAnalyticsData.length){
        res.push(
            [
                this.$t('viewAnalytics.finances.ARPU.title'),
                this.$t('viewAnalytics.sum')+'('+this.currencySymbol+')',
                {type: 'string', role: 'tooltip'},
            ],
        );
        this.orderAnalyticsData.forEach((item)=>{
          res.push([
              item.name,
              parseFloat(item.ARPU),
              item.name+'\n'+this.$t('viewAnalytics.finances.ARPU.title')+': '+this.formatCurrency(parseFloat(item.ARPU)),
          ]);
        });
        return res;
      }
      return null;
    },
    ARPUByWorkersOptions(){
      if (!this.chartsLib) return null;

      let cfg = {
        title: `${this.$t('viewAnalytics.finances.ARPU.title_by_workers')} [${this.$t('viewAnalytics.from')} ${this.startDateFormatted} ${this.$t('viewAnalytics.to')} ${this.endDateFormatted}]`,
        colors: ['#2cb124'],
        legend: {position: 'none'}
      }
      return {...this.commonChartOptions, ...cfg};
    },

    totalNumberOfDealsData(){
      let res = [];
      if(this.orderAnalyticsData.length){
        res.push(
            [this.$t('viewAnalytics.finances.total_number_of_deals'), this.$t('viewAnalytics.finances.amount')]
        );
        this.orderAnalyticsData.forEach((item)=>{
          res.push([item.name, parseFloat(item.total_number_of_deals)]);
        });
        return res;
      }
      return null;
    },
    totalNumberOfDealsOptions(){
      if (!this.chartsLib) return null;

      let cfg = {
        vAxis: {
          maxValue:10,
          format: 'decimal',
        },
        title: `${this.$t('viewAnalytics.finances.total_number_of_deals')} [${this.$t('viewAnalytics.from')} ${this.startDateFormatted} ${this.$t('viewAnalytics.to')} ${this.endDateFormatted}]`,
        colors: ['#be2c1a'],
        legend: {position: 'none'}
      }
      return {...this.commonChartOptions, ...cfg};
    },

    partsAndRepairtimeSumData(){
      let res = [];
      if(this.orderAnalyticsData.length){
        res.push(
            [
                this.$t('viewAnalytics.finances.sold_repairtimes_and_works')+' ('+this.currencySymbol+')',
                this.$t('viewAnalytics.finances.repairtime_sum_with_margin')+' ('+this.currencySymbol+')',
                {type: 'string', role: 'tooltip'},
                this.$t('viewAnalytics.finances.part_sum_with_margin')+' ('+this.currencySymbol+')',
                {type: 'string', role: 'tooltip'},
            ]
        );
        this.orderAnalyticsData.forEach((item)=>{
          res.push([
              item.name,

              parseFloat(item.repairtime && item.repairtime.sum_with_margin || 0),
              item.name+'\n'+this.$t('viewAnalytics.finances.repairtime_sum_with_margin')+': '+this.formatCurrency(parseFloat(item.repairtime && item.repairtime.sum_with_margin || 0)),

              parseFloat(item.part && item.part.sum_with_margin || 0),
              item.name+'\n'+this.$t('viewAnalytics.finances.part_sum_with_margin')+': '+this.formatCurrency(parseFloat(item.part && item.part.sum_with_margin || 0)),
          ]);
        });
        return res;
      }
      return null;
    },
    partsAndRepairtimeSumOptions(){
      if (!this.chartsLib) return null;

      let cfg = {
        vAxis: {
          maxValue:10,
          format: 'decimal',
        },
        title: `${this.$t('viewAnalytics.finances.sold_repairtimes_and_works')} [${this.$t('viewAnalytics.from')} ${this.startDateFormatted} ${this.$t('viewAnalytics.to')} ${this.endDateFormatted}]`,
        colors: ['#d67300', '#009408', '#0055ff']
      }
      return {...this.commonChartOptions, ...cfg};
    },

    sumRepairtimesData(){
      let res = [];
      if(this.orderAnalyticsData.length){
        res.push(
            [this.$t('viewAnalytics.finances.sum_repairtimes'), this.$t('viewAnalytics.finances.hours'), this.$t('viewAnalytics.finances.planned')]
        );
        this.orderAnalyticsData.forEach((item)=>{
          let userTargetRepairtimesPerDay = this.added.find(el =>{
            return (el.parameter === 'repairtimes_per_day' && ( parseInt(el.user_id) === parseInt(item.user_id)))
          });
          userTargetRepairtimesPerDay = userTargetRepairtimesPerDay ? parseFloat(userTargetRepairtimesPerDay.value) : 0;

          res.push([item.name, parseFloat(item.repairtime && item.repairtime.sum_repairtimes) || 0, parseFloat(userTargetRepairtimesPerDay*this.intervalDaysCount)]);
        });
        return res;
      }
      return null;
    },
    sumRepairtimesOptions(){
      if (!this.chartsLib) return null;

      let cfg = {
        vAxis: {
          maxValue:10,
          format: 'decimal',
        },
        title: `${this.$t('viewAnalytics.finances.sum_repairtimes')} [${this.$t('viewAnalytics.from')} ${this.startDateFormatted} ${this.$t('viewAnalytics.to')} ${this.endDateFormatted}]`,
        colors: ['#d65308', '#0055ff'],
        legend: {position: 'none'}
      }
      return {...this.commonChartOptions, ...cfg};
    },

    //Доля запчастей
    proportionOfPartsData(){
      let res = [];

      if(this.orderAnalyticsData.length){
        res.push(
            [
                this.$t('viewAnalytics.finances.proportion_of_parts'),
                this.$t('viewAnalytics.finances.in_fact')+'%',
                {type: 'string', role: 'tooltip'},
                this.$t('viewAnalytics.finances.planned')+'%',
                {type: 'string', role: 'tooltip'}
            ]
        );
        this.orderAnalyticsData.forEach((item)=>{
          let userTargetProportionsOfParts = this.added.find(el =>{
            return (el.parameter === 'proportion_of_parts' && ( parseInt(el.user_id) === parseInt(item.user_id)))
          });
          userTargetProportionsOfParts = userTargetProportionsOfParts ? parseFloat(userTargetProportionsOfParts.value) : 0;
          res.push([
              item.name,
              parseFloat(item.proportion_of_parts) || 0,
              item.name+'\n'+this.$t('viewAnalytics.finances.in_fact')+': '+parseFloat(item.proportion_of_parts || 0)+'%',
              parseFloat(userTargetProportionsOfParts),
              item.name+'\n'+this.$t('viewAnalytics.finances.planned')+': '+parseFloat(userTargetProportionsOfParts)+'%',
          ]);
        });
        return res;
      }
      return null;
    },
    proportionOfPartsOptions(){
      if (!this.chartsLib) return null;

      let cfg = {
        vAxis: {
          maxValue:100,
        },
        title: `${this.$t('viewAnalytics.finances.proportion_of_parts')} [${this.$t('viewAnalytics.from')} ${this.startDateFormatted} ${this.$t('viewAnalytics.to')} ${this.endDateFormatted}]`,
        colors: ['#aa36ff', '#0055ff'],
        legend: {position: 'none'}
      }
      return {...this.commonChartOptions, ...cfg};
    },

    orderAnalyticsHeader() {
      return [
        {text: this.$t('viewAnalytics.finances.worker'), value: 'name', sortable: true},
        {text: this.$t('viewAnalytics.finances.total_number_of_deals'), value: 'total_number_of_deals', sortable: true}, //Кол-во сделок
        {text: this.$t('viewAnalytics.finances.repairtime_sum_with_margin'), value: 'repairtime.sum_with_margin', sortable: true, class: "text-no-wrap"}, //Продано работ
        {text: this.$t('viewAnalytics.finances.part_sum_with_margin'), value: 'part.sum_with_margin', sortable: true, class: "text-no-wrap"}, //Продано запчастей
        {text: this.$t('viewAnalytics.finances.sum_repairtimes'), value: 'repairtime.sum_repairtimes', sortable: true}, //Закрыто часов
        {text: this.$t('viewAnalytics.finances.total_sum_with_margin'), value: 'total_sum_with_margin', sortable: true, "item-class": "text-no-wrap"}, //Выручка
        {text: this.$t('viewAnalytics.finances.repairtimes_per_deal'), value: 'repairtimes_per_deal', sortable: true}, //НЧ на 1 МЗД
        {text: this.$t('viewAnalytics.finances.ARPU.title'), value: 'ARPU', sortable: true, class: "text-no-wrap"}, //Средний чек
        {text: this.$t('viewAnalytics.finances.proportion_of_parts'), value: 'proportion_of_parts', sortable: true}, //Доля запчастей
        {text: this.$t('viewAnalytics.finances.average_cost_repairtime'), value: 'average_cost_repairtime', sortable: true, class: "text-no-wrap"}, //Ср. стоим. НЧ
        {text: this.$t('viewAnalytics.finances.average_margin_for_parts'), value: 'average_margin_for_parts', sortable: true}, //Наценка на запчасти
        {text: this.$t('viewAnalytics.finances.part_sum_without_margin'), value: 'part.sum_without_margin', sortable: true, class: "text-no-wrap"}, //Себестоимость запасных частей
        {text: this.$t('viewAnalytics.finances.gross_profit_per_order'), value: 'gross_profit_per_order', sortable: true, class: "text-no-wrap"}, //Валовая Прибыль на 1 ЗН

      ];
    },
  },
  methods: {
    onChartReady (chart, google) {
      this.chartsLib = google
    },
    changeInterval(){
      this.$store.dispatch('analytics/get', {
        type: 'workers_repairtimes',
        start_date: this.dateInterval.start,
        end_date: this.dateInterval.end,
      });

      this.$store.dispatch('analytics/get', {
        type: 'order_analytics', //order_analytics
        start_date: this.dateInterval.start,
        end_date: this.dateInterval.end,
      });
    }
  }
}
</script>

<style scoped>

</style>